"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var data_point_group_model_1 = require("../model/data-point-group.model");
/**
 * @author gevorg.avetisyan on 2/15/2017.
 */
var Util = /** @class */ (function () {
    function Util() {
    }
    Util.getDataPointGroupWithPeriod = function (dataPoints, periods) {
        return new data_point_group_model_1.DataPointGroup(dataPoints, periods);
    };
    /**
     * Prepare dynamic dataPoints to view
     */
    Util.prepareDynamicDataPoints = function (dataPoints, isQualitative, dataPointService, dataPointGroupId) {
        if (isQualitative && dataPoints) {
            dataPointService.getDataPointGroups().subscribe(function (res) {
                var dataPointGroup;
                for (var _i = 0, _a = res.getData(); _i < _a.length; _i++) {
                    dataPointGroup = _a[_i];
                    if (dataPointGroupId === dataPointGroup.getId()) {
                        break;
                    }
                }
                for (var _b = 0, dataPoints_1 = dataPoints; _b < dataPoints_1.length; _b++) {
                    var dataPoint = dataPoints_1[_b];
                    if (Util.getStaticDataPointIds().indexOf(dataPoint.id) === -1) {
                        dataPoint.name = dataPointGroup.getMultilingualName();
                        dataPoint.id = dataPointService.dataPointIdGenerator--;
                    }
                }
            });
        }
    };
    Util.getStaticDataPointIds = function () {
        return [1002131, 1002132, 1002133, 1005695];
    };
    return Util;
}());
exports.Util = Util;
//# sourceMappingURL=meta.util.js.map